module.exports = __webpack_public_path__ + "static/step-5.8ced8e00.png";